export const bulkUpdateSteps = {
  initial: 'initailStep',
  history: 'historyStep',
  uploadFile: 'uploadFile'
}